module.exports = __webpack_public_path__ + "img/preview-6.35828301.png";